import { NavLink } from 'react-router-dom';
import { NAV_ITEMS } from './nav';

export function Sidebar() {
  return (
    <aside
      className="flex flex-col gap-0.5 px-2.5 py-3.5 border-r border-border min-h-0"
      style={{ background: 'var(--sidebar-bg)' }}
    >
      <div className="flex items-center gap-2.5 px-2.5 pt-1 pb-3.5">
        <div className="w-7 h-7 rounded-lg bg-accent text-accent-text flex items-center justify-center text-sm font-bold">
          Q
        </div>
        <div>
          <div className="text-[13.5px] font-semibold leading-tight -tracking-[0.01em]">
            Qualibot<span className="text-text-3">.pro</span>
          </div>
          <div className="text-[10.5px] text-text-3 mt-0.5">Enterprise Demo · Pro</div>
        </div>
      </div>

      <nav className="flex flex-col gap-0.5">
        {NAV_ITEMS.map(({ id, label, path, icon: Icon }) => (
          <NavLink
            key={id}
            to={path}
            className={({ isActive }) =>
              [
                'flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-[13px] no-underline',
                isActive
                  ? 'font-semibold text-accent-strong bg-accent-soft'
                  : 'font-normal text-sidebar-text hover:bg-surface-2',
              ].join(' ')
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={15} strokeWidth={isActive ? 1.9 : 1.6} />
                {label}
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
